import TranslatedText from './TranslatedTextV1';
import TranslatedTextV2 from './TranslatedTextV2';

export default TranslatedText;

export { TranslatedTextV2 };
